import { API_BASE_URL } from "../utils/employeeHelpers";

function createRequestError(payload, status) {
  const error = new Error(payload.message || "Request failed.");
  error.status = status;
  error.code = payload.code || "";
  error.data = payload;
  return error;
}

export async function requestJson(endpoint, options = {}) {
  const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json()
    : { message: await response.text() };

  if (!response.ok) {
    throw createRequestError(payload, response.status);
  }

  return payload;
}

export function loginEmployee(payload) {
  return requestJson("/instateam/auth/employee/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function getCurrentEmployee(token) {
  return requestJson("/instateam/auth/employee/me", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
